export default __webpack_public_path__ + "static/assets/1f87b53c8a4428136e59b316287b452d.svg";